import manifestManager from "flow/utils/manifestManager";
import config from "flow/config";
import { WorkspaceModel } from "flow/entities/WorkspaceModel";
import environment from "flow/configuration/environment";

let workspaceModel: WorkspaceModel;

export function saveManifestsForLaterRegistration(model: WorkspaceModel) {
    workspaceModel = model;
}

export function registerComponents() {
    if (manifestManager.getCustomGroupMenuManifests(config.customGroupMenuType.selectPerson).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.customGroupMenuManifest], undefined);
    }

    if (manifestManager.getConfigItemManifests() && manifestManager.getConfigItemManifests().length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.configMenuManifest], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.search).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.searchMenuManifest], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.config).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.configMenuManifest2], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.statistics).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.statisticsMenuManifest], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.compilations).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.compilationsMenuManifest], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.supportDocuments).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.supportDocumentMenuManifest], undefined);
    }

    if (manifestManager.getGroupMenuManifests(config.groupMenuType.backgroundJobs).length > 0) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.backgroundJobsMenuManifest], undefined);
    }

    if (environment.get(environment.keys.themeSelector)) {
        manifestManager.addManifests(config.moduleId, [workspaceModel.themeSelectorManifest], undefined);
    }
}
